import Vue from 'vue';
//import Vuetify from 'vuetify/lib';
import Vuetify from 'vuetify'
// https://rinoguchi.net/2020/05/vue-firebase-reduce-bundle-size.html

Vue.use(Vuetify);

export default new Vuetify({
});
